export default [
    {
        "pool":"Bug",
        "range1":"TR60 (X-Scissor)",
        "range2":"TR18 (Leech Life)",
        "range3":"Bright Powder",
        "range4":"Wishing Piece",
        "range5":"Silver Powder",
        "range6":"Balm Mushroom",
        "range7":"TR61 (Bug Buzz)",
        "range8":"Shed Shell",
        "range9":"Pearl String",
        "range10":"TR96 (Pollen Puff)",
        "range11":"Comet Shard",
        "range12":"TR28 (Megahorn)",
        "range13":"Rare Candy",
        "range14":"Bottle Cap",
        "range15":"PP Up"
    },
    {
        "pool":"Dark",
        "range1":"TR37 (Taunt)",
        "range2":"Wide Lens",
        "range3":"TR68 (Nasty Plot)",
        "range4":"Wishing Piece",
        "range5":"Star Piece",
        "range6":"Balm Mushroom",
        "range7":"TR81 (Foul Play)",
        "range8":"Scope Lens",
        "range9":"TR95 (Throat Chop)",
        "range10":"TR58 (Dark Pulse)",
        "range11":"TR32 (Crunch)",
        "range12":"TR93 (Darkest Lariat)",
        "range13":"Rare Candy",
        "range14":"Bottle Cap",
        "range15":"PP Up"
    },
    {
        "pool":"Dragon",
        "range1":"TR47 (Dragon Claw)",
        "range2":"Dragon Fang",
        "range3":"Big Mushroom",
        "range4":"Wishing Piece",
        "range5":"Star Piece",
        "range6":"Balm Mushroom",
        "range7":"Dragon Scale",
        "range8":"Life Orb",
        "range9":"TR62 (Dragon Pulse)",
        "range10":"King's Rock",
        "range11":"TR51 (Dragon Dance)",
        "range12":"TR24 (Outrage)",
        "range13":"Rare Candy",
        "range14":"Bottle Cap",
        "range15":"PP Up"
    },
    {
        "pool":"Electric",
        "range1":"Electric Seed",
        "range2":"TR80 (Electro Ball)",
        "range3":"Cell Battery",
        "range4":"Wishing Piece",
        "range5":"Magnet",
        "range6":"TR86 (Wild Charge)",
        "range7":"Upgrade",
        "range8":"Light Ball",
        "range9":"Pearl String",
        "range10":"Dubious Disc",
        "range11":"TR08 (Thunderbolt)",
        "range12":"TR09 (Thunder)",
        "range13":"Rare Candy",
        "range14":"Bottle Cap",
        "range15":"PP Up"
    },
    {
        "pool":"Fairy",
        "range1":"Stardust",
        "range2":"Misty Seed",
        "range3":"Big Mushroom",
        "range4":"Wishing Piece",
        "range5":"Sachet",
        "range6":"Room Service",
        "range7":"Whipped Dream",
        "range8":"Destiny Knot",
        "range9":"<sweet_rewards1>",
        "range10":"TR92 (Dazzling Gleam)",
        "range11":"<sweet_rewards2>",
        "range12":"TR90 (Play Rough)",
        "range13":"Rare Candy",
        "range14":"Bottle Cap",
        "range15":"PP Up"
    },
    {
        "pool":"Fighting",
        "range1":"TR07 (Low Kick)",
        "range2":"TR56 (Aura Sphere)",
        "range3":"Muscle Band",
        "range4":"Wishing Piece",
        "range5":"TR48 (Bulk Up)",
        "range6":"TR21 (Reversal)",
        "range7":"Macho Brace",
        "range8":"TR99 (Body Press)",
        "range9":"Expert Belt",
        "range10":"TR64 (Focus Blast)",
        "range11":"TR39 (Superpower)",
        "range12":"TR53 (Close Combat)",
        "range13":"Rare Candy",
        "range14":"Bottle Cap",
        "range15":"PP Up"
    },
    {
        "pool":"Fire",
        "range1":"TR88 (Heat Crash)",
        "range2":"Flame Orb",
        "range3":"TR41 (Blaze Kick)",
        "range4":"Wishing Piece",
        "range5":"TR02 (Flamethrower)",
        "range6":"Balm Mushroom",
        "range7":"TR36 (Heat Wave)",
        "range8":"Red Card",
        "range9":"TR15 (Fire Blast)",
        "range10":"Charcoal",
        "range11":"TR55 (Flare Blitz)",
        "range12":"TR43 (Overheat)",
        "range13":"Rare Candy",
        "range14":"Bottle Cap",
        "range15":"PP Up"
    },
    {
        "pool":"Flying",
        "range1":"Pretty Feather",
        "range2":"Sharp Beak",
        "range3":"Big Mushroom",
        "range4":"Wishing Piece",
        "range5":"Air Balloon",
        "range6":"Blunder Policy",
        "range7":"Grip Claw",
        "range8":"Air Balloon",
        "range9":"Weakness Policy",
        "range10":"TR89 (Hurricane)",
        "range11":"Comet Shard",
        "range12":"TR66 (Brave Bird)",
        "range13":"Rare Candy",
        "range14":"Bottle Cap",
        "range15":"PP Up"
    },
    {
        "pool":"Ghost",
        "range1":"Odd Incense",
        "range2":"Adrenaline Orb",
        "range3":"Ring Target",
        "range4":"Wishing Piece",
        "range5":"Star Piece",
        "range6":"Balm Mushroom",
        "range7":"Cleanse Tag",
        "range8":"Spell Tag",
        "range9":"Cracked Pot",
        "range10":"Reaper Cloth",
        "range11":"Comet Shard",
        "range12":"TR33 (Shadow Ball)",
        "range13":"Rare Candy",
        "range14":"Bottle Cap",
        "range15":"PP Up"
    },
    {
        "pool":"Grass",
        "range1":"Grassy Seed",
        "range2":"TR59 (Seed Bomb)",
        "range3":"White Herb",
        "range4":"Wishing Piece",
        "range5":"TR77 (Grass Knot)",
        "range6":"TR50 (Leaf Blade)",
        "range7":"TR65 (Energy Ball)",
        "range8":"Absorb Bulb",
        "range9":"Pearl String",
        "range10":"TR72 (Power Whip)",
        "range11":"Comet Shard",
        "range12":"TR71 (Leaf Storm)",
        "range13":"Rare Candy",
        "range14":"Bottle Cap",
        "range15":"PP Up"
    },
    {
        "pool":"Ground",
        "range1":"Stardust",
        "range2":"TR23 (Spikes)",
        "range3":"Big Mushroom",
        "range4":"Wishing Piece",
        "range5":"Light Clay",
        "range6":"TR87 (Drill Run)",
        "range7":"TR67 (Earth Power)",
        "range8":"Terrain Extender",
        "range9":"Pearl String",
        "range10":"TR94 (High Horsepower)",
        "range11":"Comet Shard",
        "range12":"TR10 (Earthquake)",
        "range13":"Rare Candy",
        "range14":"Bottle Cap",
        "range15":"PP Up"
    },
    {
        "pool":"Ice",
        "range1":"Snowball",
        "range2":"Icy Rock",
        "range3":"Never-Melt Ice",
        "range4":"Wishing Piece",
        "range5":"Star Piece",
        "range6":"Balm Mushroom",
        "range7":"Razor Claw",
        "range8":"Snowball",
        "range9":"Pearl String",
        "range10":"TR05 (Ice Beam)",
        "range11":"Comet Shard",
        "range12":"TR06 (Blizzard)",
        "range13":"Rare Candy",
        "range14":"Bottle Cap",
        "range15":"PP Up"
    },
    {
        "pool":"Normal",
        "range1":"TR85 (Work Up)",
        "range2":"TR14 (Metronome)",
        "range3":"TR26 (Endure)",
        "range4":"TR13 (Focus Energy)",
        "range5":"TR27 (Sleep Talk)",
        "range6":"TR35 (Uproar)",
        "range7":"TR01 (Body Slam)",
        "range8":"TR19 (Tri Attack)",
        "range9":"TR29 (Baton Pass)",
        "range10":"TR30 (Encore)",
        "range11":"TR20 (Substitute)",
        "range12":"TR00 (Swords Dance)",
        "range13":"TR42 (Hyper Voice)",
        "range14":"Bottle Cap",
        "range15":"PP Up"
    },
    {
        "pool":"Poison",
        "range1":"Black Sludge",
        "range2":"Toxic Orb",
        "range3":"TR91 (Venom Drench)",
        "range4":"Wishing Piece",
        "range5":"TR54 (Toxic Spikes)",
        "range6":"Smoke Ball",
        "range7":"TR57 (Poison Jab)",
        "range8":"Quick Powder",
        "range9":"Poison Barb",
        "range10":"TR22 (Sludge Bomb)",
        "range11":"TR78 (Sludge Wave)",
        "range12":"TR73 (Gunk Shot)",
        "range13":"Rare Candy",
        "range14":"Bottle Cap",
        "range15":"PP Up"
    },
    {
        "pool":"Psychic",
        "range1":"TR12 (Agility)",
        "range2":"TR34 (Future Sight)",
        "range3":"TR40 (Skill Swap)",
        "range4":"TR82 (Stored Power)",
        "range5":"TR44 (Cosmic Power)",
        "range6":"TR83 (Ally Switch)",
        "range7":"TR25 (Psyshock)",
        "range8":"TR69 (Zen Headbutt)",
        "range9":"TR17 (Amnesia)",
        "range10":"TR38 (Trick)",
        "range11":"TR49 (Calm Mind)",
        "range12":"TR97 (Psychic Fangs)",
        "range13":"TR11 (Psychic)",
        "range14":"Bottle Cap",
        "range15":"PP Up"
    },
    {
        "pool":"Rock",
        "range1":"Float Stone",
        "range2":"Oval Stone",
        "range3":"Hard Stone",
        "range4":"Wishing Piece",
        "range5":"Everstone",
        "range6":"Protector",
        "range7":"Rocky Helmet",
        "range8":"TR63 (Power Gem)",
        "range9":"Wishing Piece",
        "range10":"Eviolite",
        "range11":"TR76 (Stealth Rock)",
        "range12":"TR75 (Stone Edge)",
        "range13":"Rare Candy",
        "range14":"Bottle Cap",
        "range15":"PP Up"
    },
    {
        "pool":"Steel",
        "range1":"TR31 (Iron Tail)",
        "range2":"TR46 (Iron Defense)",
        "range3":"Metal Powder",
        "range4":"Wishing Piece",
        "range5":"Utility Umbrella",
        "range6":"Metal Coat",
        "range7":"TR52 (Gyro Ball)",
        "range8":"Assault Vest",
        "range9":"TR79 (Heavy Slam)",
        "range10":"Amulet Coin",
        "range11":"TR70 (Flash Cannon)",
        "range12":"TR74 (Iron Head)",
        "range13":"Rare Candy",
        "range14":"Bottle Cap",
        "range15":"PP Up"
    },
    {
        "pool":"Water",
        "range1":"Sea Incense",
        "range2":"TR04 (Surf)",
        "range3":"Shell Bell",
        "range4":"Wishing Piece",
        "range5":"TR16 (Waterfall)",
        "range6":"TR98 (Liquidation)",
        "range7":"Prism Scale",
        "range8":"Mystic Water",
        "range9":"Pearl String",
        "range10":"TR45 (Muddy Water)",
        "range11":"TR84 (Scald)",
        "range12":"TR03 (Hydro Pump)",
        "range13":"Rare Candy",
        "range14":"Bottle Cap",
        "range15":"PP Up"
    }
]